import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, Link } from "react-router-dom";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";

const CategoryView = () => {
  const { id } = useParams();
  const [record, setRecord] = useState(null);
  const [parentName, setParentName] = useState("-");
  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (key, defaultValue) => translations[key] || defaultValue;

  useEffect(() => {
    const load = async () => {
      try {
        const r = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/stock-categories/${id}`,
        );
        setRecord(r.data);

        //  Parent başlığını al
        if (r.data.parent_id) {
          const parents = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/api/stock-categories/list-simple`,
          );
          const parent = parents.data.find((x) => x.id === r.data.parent_id);
          setParentName(parent?.title || "-");
        }
      } catch {
        console.error("Kategori bulunamadı");
      }
    };

    load();
  }, [id]);

  if (!record) return <p>{getText("LOADING")}</p>;

  return (
    <div className="container mt-4">
      <div className="card shadow-sm p-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="fw-bold">{record.title}</h4>
          <Link to="/categories/table" className="btn btn-sm btn-secondary">
            {getText("BACK")}
          </Link>
        </div>

        {/*  Görsel */}
        {record.image && (
          <div className="mb-3 text-center">
            <img
              src={`${process.env.REACT_APP_API_BASE_URL}${record.image}`}
              alt={record.title}
              className="img-fluid rounded"
              style={{ maxHeight: 250, objectFit: "cover" }}
            />
          </div>
        )}

        {/*  Bilgi Tablosu */}
        <table className="table table-bordered">
          <tbody>
            <tr>
              <th style={{ width: 200 }}>{getText("PARENT_CATEGORY_LABEL")}</th>
              <td>{parentName}</td>
            </tr>
            <tr>
              <th>{getText("STATUS_LABEL")}</th>
              <td>
                <span
                  className={`badge ${
                    record.status === "aktif" ? "bg-success" : "bg-danger"
                  }`}
                >
                  {record.status === "aktif"
                    ? getText("STATUS_ACTIVE")
                    : getText("STATUS_PASSIVE")}
                </span>
              </td>
            </tr>
      <tr>
  <th>{getText("BRAND_LABEL")}</th>
  <td>
    <span
      className={`badge ${
        record.brand_option === "evet"
          ? "bg-success"
          : "bg-danger"
      }`}
    >
      {record.brand_option === "evet"
        ? getText("YES_LABEL")
        : record.brand_option === "hayir"
          ? getText("NO_LABEL")
          : "-"}
    </span>
  </td>
</tr>

            <tr>
              <th>{getText("SEO_TITLE_LABEL")}</th>
              <td>{record.seo_title || "-"}</td>
            </tr>
            <tr>
              <th>{getText("SEO_DESCRIPTION_LABEL")}</th>
              <td>{record.seo_description || "-"}</td>
            </tr>
            <tr>
              <th>{getText("SEO_KEYWORDS_LABEL")}</th>
              <td>{record.seo_keywords || "-"}</td>
            </tr>
          </tbody>
        </table>

        {/*  İçerik */}
        <div className="mt-4">
          <h5 className="fw-bold">{getText("CONTENT_TITLE")}</h5>
          <div
            className="p-3 border rounded bg-light"
            dangerouslySetInnerHTML={{
              __html: record.content || `<i>${getText("NO_CONTENT")}</i>`,
            }}
          />
        </div>

      </div>
    </div>
  );
};

export default CategoryView;
